import {
  CheckLendCollectionListRequestCollection,
  CheckLendCollectionListRequestCollectionToJSON
} from '@/api'

export interface CheckLendCollectionListRequest {
  userId: string
  collections: CheckLendCollectionListRequestCollection[]
  isReading: boolean
}

export function CheckLendCollectionListRequestToJSON(
  value: CheckLendCollectionListRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    collections:
      value.collections.length > 0
        ? value.collections.map(CheckLendCollectionListRequestCollectionToJSON)
        : undefined,
    is_reading: value.isReading ?? undefined
  }
}
